<template>
  <div v-bind:class="rowClass" v-bind:style="rowStyle">
    <div class="form-group has-label">
      <label v-if="labelSelect.length > 1"
        ><span v-html="labelSelect"></span
      ></label>
      <br v-if="labelSelect.length > 1" />
      <el-select
        :disabled="disabled"
        clearable
        v-bind:multiple="isMultiple"
        v-bind:collapse-tags="true"
        filterable
        @change="handleChange"
        @clear="handleClear"
        v-bind:class="`select-primary custom-width-select shadow-sm ${requireClass}`"
        size="large"
        v-model="model.selecteds"
        :placeholder="getPlaceHolder"
      >
        <el-option
          v-for="(option, index) in listOptions"
          v-bind:class="`select-primary ${isMultiple ? `selected-all` : ``}`"
          v-bind:value="getValueOption(option)"
          v-bind:label="getValueLabel(option)"
          v-bind:disabled="option.disabled ? option.disabled : false"
          :key="index"
        ></el-option>
      </el-select>
    </div>
  </div>
</template>
<script>
import { isNumber } from 'highcharts';
import { isset } from 'src/util/Util.js';
import i18n from '../../i18n';
import MixinMasters from 'src/util/mixinMasters';
import MixinTranslate from 'src/util/mixinTranslate';

export default {
  name: 'select-component',
  mixins: [MixinMasters, MixinTranslate],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: null,
    },
    dataOptions: {
      type: Array | Object,
    },
    isMultiple: {
      type: Boolean,
      default: true,
      description: 'Use it when you want the component is multiple',
    },
    labelSelect: {
      type: String,
      default: ' ',
    },
    modelInitial: {
      type: String | Number,
      default: '',
    },
    modelName: {
      type: String,
      default: '',
    },
    requireClass: {
      type: String,
      default: '',
    },
    rowClass: {
      type: String,
      default: 'col-12',
    },
    rowStyle: {
      type: String,
      default: '',
    },
    initialSelection: {
      type: String | Number | null,
      default: null,
    },
    valueLabel: {
      type: String | Number,
      default: 'name',
    },
    valueOption: {
      type: String | Number,
      default: 'id',
    },
    indexSelect: {
      type: String | Number,
      default: 0,
    },
  },

  watch: {
    initialSelection(newValue) {
      this.$set(this.model, 'selecteds', newValue);
    },
    dataOptions(newValue) {
      if (newValue && newValue.length >= 0) {
        this.listOptions = [...newValue];
      }
    },
  },

  computed: {
    getPlaceHolder() {
      return this.placeholder
        ? this.placeholder
        : `${i18n.t('common_words.select')}...`;
    },
  },

  data() {
    return {
      model: {
        selecteds: this.isMultiple ? [] : null,
      },
      listOptions: [],
    };
  },

  methods: {
    handleChange() {
      if (this.isMultiple) {
        this.selectAllFromSelect('model.selecteds', this.dataOptions);
      }

      this.$emit('onChange', {
        name: this.modelName,
        selects: this.model.selecteds,
        index: this.indexSelect,
      });
    },

    handleClear() {
      if (this.isMultiple) this.model.selecteds = [];
      else this.model.selecteds = null;
      this.$emit('onClear');
    },

    getValueOption(option) {
      if (this.valueOption === 'option') return option;
      const index = !isNumber(this.valueOption)
        ? `.${this.valueOption}`
        : `[${this.valueOption}]`;

      return eval(`JSON.parse(JSON.stringify(option))${index}`);
    },

    getValueLabel(option) {
      if (this.valueLabel === 'option') return option;
      const index = !isNumber(this.valueLabel)
        ? `.${this.valueLabel}`
        : `[${this.valueLabel}]`;

      const otherValue = option.other_values ? option.other_values : null;

      const response = this.translateDataBaseText(
        eval(`JSON.parse(JSON.stringify(option))${index}`),
        otherValue
      );

      return response && response.replace(/^0 - /, '');
    },
  },

  mounted() {
    const initialData = this.initialSelection || this.modelInitial;
    const isArray = Array.isArray(initialData);

    if (isset(initialData)) {
      if (this.isMultiple) {
        if (isArray) {
          this.model.selecteds = initialData.slice();
        } else {
          if (!Array.isArray(this.model.selecteds)) {
            this.$set(this.model, 'selecteds', []);
          }
          this.model.selecteds.push(initialData);
        }
      } else {
        this.model.selecteds = initialData;
      }
    } else {
      this.model.selecteds = this.isMultiple ? [] : null;
    }

    if (this.dataOptions && Object.values(this.dataOptions).length >= 0) {
      if (Array.isArray(this.dataOptions))
        this.listOptions = [...this.dataOptions];
      else this.listOptions = { ...this.dataOptions };
    }
  },
};
</script>
